import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {AudioPlayer} from './AudioPlayer';

const StoneAudioPlayerCore = (
    {sound = false, volume = 0.5}: {sound?: boolean; volume?: number},
    ref: any
) => {
    const audioRef = useRef<HTMLAudioElement>(null);

    const play = () => {
        if (sound) audioRef.current?.play();
    };

    useImperativeHandle(
        ref,
        () => ({
            play,
        }),
        [sound]
    );

    return (
        <AudioPlayer
            src={'/build/audios/move.ogg'}
            ref={audioRef}
            volume={volume}
        />
    );
};

export const StoneAudioPlayer = forwardRef(StoneAudioPlayerCore);
